import { getEffectiveGradingTeams, formatGradingTeams } from './gradingTeams';

export function dateFromStockFilename(name) {
  const iso=name.match(/(?:^|[^0-9])(20\d{2})[- _.](\d{2})[- _.](\d{2})(?![0-9])/);
  const uk=name.match(/(?:^|[^0-9])(\d{2})[- _.](\d{2})[- _.](20\d{2})(?![0-9])/);
  const date=iso?`${iso[1]}-${iso[2]}-${iso[3]}`:uk?`${uk[3]}-${uk[2]}-${uk[1]}`:'';
  if(!date)return '';
  const parsed=new Date(date+'T12:00:00Z');
  return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0,10)===date?date:'';
}
export function stockDateTime(date) {
  if(!/^\d{4}-\d{2}-\d{2}$/.test(date))throw new Error('Choose a report date.');
  const noon=new Date(date+'T12:00:00Z');
  const hour=Number(new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',hour:'2-digit',hourCycle:'h23'}).format(noon));
  noon.setUTCHours(12-(hour-12));
  return noon.toISOString();
}
export function inferStockKind(name) {
  if(/power[\s_-]*bi/i.test(name))return 'powerbi';
  if(/call|back[\s_-]*order/i.test(name))return 'calls';
  return '';
}
export async function loadStockImportContext(server,team,gradeValues) {
  const [clients,grading]=await Promise.all([server.fetchStockClients(),server.fetchGrading(undefined,0)]);
  if(!Array.isArray(clients) || !Array.isArray(grading))throw new Error('Client and grading references must load before importing.');
  const refs=await Promise.all(clients.map(async c=>{
    const result=await server.fetchPartRefs(team,c.id);
    if(!Array.isArray(result?.partIds))throw new Error(`Could not load ${team} ${c.name || c.id} references.`);
    return [c.id,new Set(result.partIds)];
  }));
  const gradingLookup={};
  for(const r of grading) {
    const partId=(r.part_id || '').toUpperCase().trim(),grade=(r.grade || '').toUpperCase().trim();
    if(partId && gradeValues[grade]!==undefined) {const teams=getEffectiveGradingTeams(r);gradingLookup[partId]={grade,teams,team:formatGradingTeams(teams)};}
  }
  return {teamFilter:team,clients,gradingLookup,gradeValues,clientPartIds:Object.fromEntries(refs),clientPartIdsTeam:team};
}
